module.exports = __webpack_public_path__ + "img/corchete-header-02.f4398a31.png";